<template>
  <v-card class="campanhas-agendadas" height="344px">
    <h3 class="table-card-title pl-4 pt-4">
      Campanhas agendadas
      <span v-if="sendDate">no dia {{ DateTime.fromISO(sendDate).toFormat('dd/MM/yyyy') }}</span>
      <v-tooltip right max-width="300px">
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <mf-icon small class="ml-3 mb-1" color="cinza-0">info</mf-icon>
          </span>
        </template>
        <span>Disparos sendo utilzados por outras campanhas diminuem o total de disparos disponíveis do dia.</span>
      </v-tooltip>
    </h3>

    <v-container fluid class="pa-0" style="height: calc(100% - 44px)">
      <v-layout v-if="$apollo.queries.campaigns.loading" justify-center align-center fill-height class="px-3">
        <v-progress-linear indeterminate />
      </v-layout>
      <v-layout v-else-if="!sendDate" justify-center align-center fill-height class="px-3">
        <p class="nenhuma-campanha">Selecione uma data de envio para visualizar as campanhas já agendadas</p>
      </v-layout>
      <v-layout v-else-if="!senders || !senders.length" justify-center align-center fill-height class="px-3">
        <p class="nenhuma-campanha">Selecione disparadores para visualizar as campanhas já agendadas</p>
      </v-layout>
      <v-container v-else-if="campaigns && campaigns.length === 0" justify-center align-center fill-height class="px-3">
        <v-row no-gutters justify="center" align="center">
          <v-spacer />
          <v-col class="pa-0" cols="12" justify="center" align="center">
            <v-img height="170px" width="170px" :src="require('@/assets/warning_cart.png')" class="responsive-image" />
          </v-col>
          <v-spacer />
        </v-row>
        <v-row no-gutters class="pt-6" justify="center" align="center">
          <p class="nenhuma-campanha">Nenhuma campanha programada nessa data com os disparadores selecionados</p>
        </v-row>
      </v-container>
      <div v-else>
        <v-data-table fixed-header height="280px" :items="campaigns" :headers="headers" hide-default-footer disable-pagination>
          <template v-slot:item.message.send_date="{ item }">
            {{ DateTime.fromISO(item.message.send_date).toFormat('dd/MM/yyyy') }}
          </template>
        </v-data-table>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import gql from 'graphql-tag'
import { DateTime } from 'luxon'

const QUERY_LIST_CAMPAIGNS = gql`
  query Campaigns($date: String, $senders: [String]) {
    campaigns(date: $date, senders: $senders, mode: WHATSAPP) {
      campaigns {
        _id
        title
        description
        initial_date
        final_date
        message {
          send_date
          send_time
        }
      }
    }
  }
`

export default {
  props: {
    sendDate: String,
    senders: Array,
  },
  data: () => ({
    campaigns: [],
    DateTime: DateTime,
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Título',
          value: 'title',
        },
        {
          text: 'Descrição',
          value: 'description',
        },
        {
          text: 'Hora de envio',
          value: 'message.send_time',
        },
      ]
    },
  },
  apollo: {
    campaigns: {
      query: QUERY_LIST_CAMPAIGNS,
      notifyOnNetworkStatusChange: true,
      update({ campaigns }) {
        if (!campaigns) return []
        return campaigns.campaigns.filter((campaign) => campaign._id !== this.$route.params.id)
      },
      skip() {
        if (!this.sendDate) return true
        if (!this.senders || !this.senders.length) return true
        return false
      },
      variables() {
        return {
          date: this.sendDate,
          senders: this.senders,
        }
      },
      context() {
        return {
          uri: this.$microservicesUrls['campaigns'],
        }
      },
      fetchPolicy: 'no-cache',
    },
  },
}
</script>

<style lang="scss">
.campanhas-agendadas {
  .image-container {
    height: 170px;
    width: 170px;
  }

  .nenhuma-campanha {
    opacity: 0.5;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0.29px;
    text-align: center;
  }
}
</style>
